"use client";

import { MosaicSwitcherBlock } from "@mw/shared/payload-types";
import dynamic from "next/dynamic";

const BlockMosaicSwitcher = dynamic(() => import("./BlockMosaicSwitcher").then(mod => mod.BlockMosaicSwitcher));

export const BlockMosaicSwitcherWrapper = (props: MosaicSwitcherBlock) => {
  return <BlockMosaicSwitcher {...props} />;
};
